// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.harvest_annotation_kind */
var HarvestAnnotationKind;
(function (HarvestAnnotationKind) {
    HarvestAnnotationKind["NOTE"] = "NOTE";
    HarvestAnnotationKind["HIGHLIGHT"] = "HIGHLIGHT";
    HarvestAnnotationKind["WARNING"] = "WARNING";
})(HarvestAnnotationKind || (HarvestAnnotationKind = {}));
;
export default HarvestAnnotationKind;
/** Zod schema for harvest_annotation_kind */
export const harvestAnnotationKind = z.nativeEnum(HarvestAnnotationKind);
//# sourceMappingURL=HarvestAnnotationKind.js.map